import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { HttpService } from '../service/http.service';
import { SchoolLviUrl } from '../school-lvi-url';
import { SchoolService } from '../service/school.service';
import { ToastMessageService } from '../toast-message.service';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-school-url-edit',
  templateUrl: './school-url-edit.component.html',
  styleUrls: ['./school-url-edit.component.css']
})
export class SchoolUrlEditComponent implements OnInit {

  schoolUrls: SchoolLviUrl[] = [];
  schoolUrlForm!: FormGroup;

  constructor(
    private httpService: HttpService,
    private schoolService: SchoolService,
    private builder: FormBuilder,
    private toastService: ToastMessageService,
    private confirmationService: ConfirmationService
  ) { }

  ngOnInit(): void {
    this.initUrlForm();
    this.httpService.getSchoolLviUrlsBySchoolId(this.schoolService.selectedSchoolId).subscribe(res => {
      this.schoolUrls = res;
      this.populateData();
    });
  }

  initUrlForm() {
    this.schoolUrlForm = this.builder.group({
      urls: this.builder.array([])
    });
  }

  addUrlToFormArray() {
    this.urlForms.push(this.builder.group({
      url: "",
      id: null
    }));
  }

  get urlForms(): FormArray {
    return this.schoolUrlForm.get("urls") as FormArray;
  }

  private populateData() {
    this.schoolUrls.forEach((data, index) => {
      this.addUrlToFormArray();
      this.urlForms.controls[index].get("url")!.setValue(data.url);
      this.urlForms.controls[index].get("id")!.setValue(data.id);
    });
  }

  postUrls() {
    if(this.urlForms.length == 0){
      this.toastService.addError("Error", "There is no URL to update");
      return;
    }
    let observables = [];
    for (let form of this.urlForms.controls) {
      if (form.value.id) {
        observables.push(
          this.httpService.putSchoolLviUrl(new SchoolLviUrl(
            form.value.url,
            form.value.id
          ))
        );
      } else {
        let obs = this.httpService.postSchoolLviUrl(new SchoolLviUrl(
          form.value.url,
        ), this.schoolService.selectedSchoolId);
        observables.push(obs);
        obs.subscribe(res => {
          form.get("id")!.setValue(res);
        });
      }
    }
    const results = forkJoin(observables);
    results.subscribe({
      complete: () => {
        this.toastService.addSuccess("Success", "Update successfull");
      },
      error: error => {
        this.toastService.addError("Error", error.message);
        console.error(error.message);
      }
    });
  }

  deleteUrl(form: FormGroup, index: number) {
    this.confirmationService.confirm({
      header: "Confirmation",
      message: "Are you sure that you want to delete this URL?",
      accept: () => {
        if(form.value.id){
          this.httpService.deleteSchoolLviUrl(form.value.id).subscribe(() => {
            this.toastService.addSuccess("Success", "Deleted");
            this.urlForms.removeAt(index);
            this.schoolUrls = this.schoolUrls.splice(index, 1);
          }, error => this.toastService.addError("Error", error.message));
        } else {
          this.urlForms.removeAt(index);
          this.schoolUrls = this.schoolUrls.splice(index, 1);
        }
      }
    });
  }

}
